// extracted by mini-css-extract-plugin
export default {"wrap":"Preloader_wrap__n0MaU","svg":"Preloader_svg__0QBYM","rotate-90-cw":"Preloader_rotate-90-cw__Lk70x"};